import React from 'react'
import { Check } from 'react-bootstrap-icons'

/**
 * The progress rail for multi-step modals (archetype F).
 *
 * Completed steps stay clickable so the user can go back and correct an
 * earlier answer; steps ahead are disabled, because they depend on choices not
 * made yet. Pass `locked` once the flow has committed — after a booking is
 * created there is nothing left to go back to.
 *
 * `steps` take { number, title, description }.
 */
const ModalStepper = ({ steps = [], current, onStepClick, locked = false }) => (
  <div className='app-modal__stepper' role='list'>
    {steps.map((step) => {
      const done = current > step.number
      const isCurrent = current === step.number
      const canGo = !locked && done && typeof onStepClick === 'function'

      return (
        <button
          key={step.number}
          type='button'
          role='listitem'
          className={[
            'app-modal__step',
            done ? 'app-modal__step--done' : '',
            isCurrent ? 'app-modal__step--current' : '',
          ]
            .filter(Boolean)
            .join(' ')}
          aria-current={isCurrent ? 'step' : undefined}
          disabled={!canGo}
          onClick={canGo ? () => onStepClick(step.number) : undefined}
        >
          <span className='app-modal__step-dot'>
            {done ? <Check /> : step.number}
          </span>
          {/* No `d-block` here: Bootstrap's utility carries `!important` and
              would beat the media query that drops the description on narrow
              screens. The block display comes from the stylesheet instead. */}
          <span>
            <span className='app-modal__step-title'>{step.title}</span>
            {step.description && (
              <span className='app-modal__step-desc'>{step.description}</span>
            )}
          </span>
        </button>
      )
    })}
  </div>
)

export default ModalStepper
